import { useMemo } from "react";
import { useDeviceInfoQuery } from "@/hooks";

export default function OnlyAndroid({ version, children }) {
  const { data } = useDeviceInfoQuery({ fetchPolicy: "cache-first" });
  const deviceInfo = data?.deviceInfo;

  const isAndroid = useMemo(() => {
    if (deviceInfo) {
      if (version) {
        return deviceInfo.isAndroid && deviceInfo.os.major <= version;
      } else {
        return deviceInfo.isAndroid;
      }
    }
    return false;
  }, [deviceInfo]);

  if (!isAndroid) return null;
  return <>{children}</>;
}
